import React, { useRef, useEffect, useState } from 'react';
import { Send, BotMessageSquare } from 'lucide-react';

const ChatInput = ({ 
  input, 
  setInput, 
  onSend, 
  loading,
  isStreaming
}) => {
  const inputRef = useRef(null);
  const [showPlaceholder, setShowPlaceholder] = useState(true);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      
      const observer = new MutationObserver(() => {
        const content = inputRef.current.innerHTML;
        setShowPlaceholder(!content || content === '<br>' || content === '<div><br></div>');
      });

      observer.observe(inputRef.current, {
        childList: true,
        characterData: true,
        subtree: true
      });

      return () => observer.disconnect();
    }
  }, []);

  const clearInput = () => {
    if (inputRef.current) {
      inputRef.current.innerHTML = '';
      setInput('');
      setShowPlaceholder(true);
    }
  };

  const handleSend = () => {
    if (isStreaming) return;
    onSend(input);
    clearInput();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isStreaming) {
        handleSend();
      }
    }
  };

  const handleInput = (e) => {
    const content = e.target.textContent || '';
    setInput(content.trim());
  };

  const isSendDisabled = isStreaming || !input.trim();

  return (
    <div className="p-4 ">
      <div className="max-w-[720px] w-full mx-auto rounded-lg border border-gray-200 shadow-sm">
        <div className="w-full px-4 py-3 relative">
          <div
            ref={inputRef}
            contentEditable
            id="input-box"
            onInput={handleInput}
            onKeyDown={handleKeyDown}
            className="w-full min-h-[30px] max-h-[160px] overflow-y-auto text-gray-800 
              bg-transparent focus:outline-none"
          />
          {showPlaceholder && (
            <div className="absolute top-3 left-4 text-gray-400 pointer-events-none">
              Type your question...
            </div>
          )}
        </div>

        <div className="flex items-center justify-end px-4 pb-2">
          {loading ? (
            <BotMessageSquare className="animate-pulse text-blue-500" size={24} />
          ) : (
            <button
              onClick={handleSend}
              disabled={isSendDisabled}
              className={`p-1 hover:bg-gray-100 rounded-md ${
                isSendDisabled
                  ? 'text-gray-300 cursor-not-allowed'
                  : 'text-blue-500 cursor-pointer'
              }`}
            >
              <Send size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatInput;